/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:41
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-09-27 18:33:18
 */
import React from 'react';
import { Progress } from '@firesoon/antd';
import { ProgressProps } from '@firesoon/antd/lib/progress/index';
import './index.less';

interface FsProgressProps extends ProgressProps {
  /** 文案 */
  text?: string;
}

const Index = (props: FsProgressProps) => {
  const { text, ...rest } = props;
  const { type = 'line', status = 'normal' } = rest;
  const isLine = type === 'line';
  const progressTextClassName = {
    normal: 'fs-progress-text-normal',
    active: 'fs-progress-text-normal',
    exception: 'fs-progress-text-exception',
    success: 'fs-progress-text-success',
  };

  return (
    <div>
      <Progress {...rest} />
      {isLine && text && <div className={`fs-progress-text ${progressTextClassName[status]}`}>{text}</div>}
    </div>
  );
};

export default Index;
